// Infrastructure layer - Token session management
// Handles token storage, retrieval, and refresh logic

import { SessionManager } from "../../features/auth/infrastructure/session/SessionManager";

const sessionManager = new SessionManager();

export const authSession = {
  getAccessToken(): string | null {
    return sessionManager.getAccessToken();
  },

  getRefreshToken(): string | null {
    return sessionManager.getRefreshToken();
  },

  setTokens(accessToken: string, refreshToken: string): void {
    sessionManager.saveTokens({
      access_token: accessToken,
      refresh_token: refreshToken,
    });
  },

  setRegionalApi(region?: {
    region_key?: string | null;
    api_base_url?: string | null;
  }): void {
    sessionManager.saveRegionalApi({
      region_key: region?.region_key ?? undefined,
      api_base_url: region?.api_base_url ?? undefined,
    });
  },

  getClinicalApiBaseUrl(): string | null {
    return sessionManager.getClinicalApiBaseUrl();
  },

  getRegionKey(): string | null {
    return sessionManager.getRegionKey();
  },

  clearTokens(): void {
    sessionManager.clearSession();
  },

  isAuthenticated(): boolean {
    return !!sessionManager.getAccessToken();
  },
};

export default authSession;
